import { NavLink, Outlet, useParams } from 'react-router-dom';
import { Layout, Typography } from 'antd';
import { HomeOutlined, CalendarOutlined, TrophyOutlined, CheckCircleOutlined, DollarOutlined, ReadOutlined } from '@ant-design/icons';

/**
 * Student surface — mobile-first shell with bottom tabs.
 */
export function StudentShell() {
  const { institution = '' } = useParams<{ institution: string }>();
  return (
    <Layout style={{ minHeight: 'calc(100vh - 50px)', background: '#f7f7f5' }}>
      <Layout.Content style={{ padding: '18px 18px 74px', maxWidth: 720, margin: '0 auto', width: '100%' }}>
        <div style={{ marginBottom: 12 }}>
          <Typography.Text type="secondary" style={{ fontSize: 11, letterSpacing: 0.4, textTransform: 'uppercase', fontWeight: 600 }}>
            Student
          </Typography.Text>
        </div>
        <Outlet />
      </Layout.Content>
      <nav
        style={{
          position: 'fixed', bottom: 0, left: 0, right: 0,
          display: 'flex', justifyContent: 'space-around',
          background: '#fff', borderTop: '1px solid #e6e6e9',
          padding: '8px 0', zIndex: 100,
        }}
      >
        <Tab to={`/i/${institution}/student`} end icon={<HomeOutlined />} label="Home" />
        <Tab to={`/i/${institution}/student/timetable`} icon={<CalendarOutlined />} label="Time" />
        <Tab to={`/i/${institution}/student/homework`} icon={<ReadOutlined />} label="Homework" />
        <Tab to={`/i/${institution}/student/marks`} icon={<TrophyOutlined />} label="Marks" />
        <Tab to={`/i/${institution}/student/attendance`} icon={<CheckCircleOutlined />} label="Attend." />
        <Tab to={`/i/${institution}/student/fees`} icon={<DollarOutlined />} label="Fees" />
      </nav>
    </Layout>
  );
}

function Tab({ to, icon, label, end }: { to: string; icon: React.ReactNode; label: string; end?: boolean }) {
  return (
    <NavLink to={to} end={end}
      style={({ isActive }) => ({
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
        textDecoration: 'none', color: isActive ? '#2f6ab0' : '#5b6478',
        fontSize: 10.5, fontWeight: isActive ? 600 : 500,
      })}
    >
      <span style={{ fontSize: 20 }}>{icon}</span>
      {label}
    </NavLink>
  );
}
